module.exports = __webpack_public_path__ + "img/really-bad-horizontal-stairs.de222ee1.gif";